<template>
  <div
    class="error-account-page"
    :style="
      verifyErrorCode === 'ERR_SD_XPUG_003'
        ? { backgroundColor: '#f6f6f6' }
        : {}
    "
  >
    <img v-if="verifyErrorCode !== 'ERR_SD_XPUG_003'" src="/wake.svg" alt="" />
    <!-- PARA QUANDO O USUÁRIO NÃO EXISTE -->
    <template
      v-if="verifyLogin === 'error' && verifyErrorCode === 'ERR_SD_XPUG_004'"
    >
      <p class="mt-3">Verificando contas associadas, aguarde...</p>
    </template>
    <!-- PARA QUANDO NÃO HÁ CONTA ASSOCIADA -->
    <template
      v-else-if="
        verifyLogin === 'error' && verifyErrorCode === 'ERR_SD_XPUG_003'
      "
    >
      <div class="error-account-page__no-account">
        <div class="row m-0">
          <div class="col-8 p-5">
            <h1>Essa versão da plataforma foi desativada 🚨</h1>
            <p>
              A nova interface da Wake Experience já está no ar e, com isso,
              esta versão foi descontinuada.
            </p>
            <p>
              Mas fique tranquilo:
              <b style="font-weight: 700">
                sua migração para a nova interface já foi realizada com sucesso.
              </b>
            </p>
            <p>Se precisar de ajuda, é só chamar seu account!</p>
            <p>Clique no botão abaixo para acessar a nova interface:</p>

            <a
              class="nave-button__info"
              style="
                background: #fff;
                outline: none;
                border: solid 1px rgba(24, 160, 251, 0.5);
                color: #18a0fb;
                border-radius: 4px;
                padding: 10px 15px;
                font-weight: 400;
                text-decoration: none;
              "
              href="https://exp.wake.tech/"
              target="_blank"
            >
              ACESSAR NOVA INTERFACE
            </a>
          </div>
          <div class="col-4 p-2">
            <img src="@/assets/img/integrations/FotoGA4.png" />
          </div>
        </div>
      </div>
    </template>
    <!-- PARA ERRO NÃO IDENTIFICADO -->
    <template v-else-if="verifyLogin === 'error'">
      <h3 class="mt-3">Ops! Algo inesperado aconteceu.</h3>
      <p>Faça login novamente ou entre em contato com seu Account Manager</p>
      <a @click="redirectToLogin">Retornar à tela de login.</a>
      <code v-if="verifyErrorCode">COD.: {{ verifyErrorCode }}</code>
    </template>
    <!-- QUANDO NÃO HÁ ACCESS TOKEN OU CODE -->
    <template v-else>
      <p class="mt-3">
        Você será redirecionando para a tela de
        <a @click="redirectToLogin">login</a>
        em {{ countDown }}...
      </p>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import keyCloak from "./common/module/keyCloak";
import userGateway from "@/common/services/userGateway";
import webStorage from "@/common/module/webStorage";
import jwt from "jwt-decode";

export default defineComponent({
  name: "Erro Account",

  setup() {
    let countDown = ref(3);
    let intervalId = 0;
    const redirectToLogin = () => {
      keyCloak.redirectAuth();
    };
    const verifyLogin = ref(keyCloak.logged);
    const verifyErrorCode = ref(keyCloak.errorCode);

    const userEmail = computed(() => {
      const userInfo: { sub: string; email: string } = jwt(
        webStorage.getItem("access_token")
      );

      return userInfo.email;
    });

    onMounted(() => {
      if (keyCloak.logged === false) {
        intervalId = window.setInterval(() => {
          countDown.value--;
          if (countDown.value === 0) {
            window.clearInterval(intervalId);
            keyCloak.redirectAuth();
          }
        }, 1000);
      }

      if (
        keyCloak.logged === "error" &&
        keyCloak.errorCode === "ERR_SD_XPUG_004"
      ) {
        userGateway
          .setUserSSO()
          .then(() => {
            keyCloak.redirectToLogin();
          })
          .catch((error) => {
            verifyErrorCode.value =
              error?.response?.data[0]?.propertyName ?? "";
          });
      }
    });

    return {
      redirectToLogin,
      verifyLogin,
      countDown,
      verifyErrorCode,
      userEmail,
    };
  },
});
</script>

<style lang="scss" scoped>
.error-account-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > h3 {
    font-family: "text-semi-bold";
    font-size: toRem(22px);
  }

  > p {
    font-family: "text-medium";
    font-size: toRem(18px);
  }

  a {
    color: var(--insights-color-23);
    font-family: "text-medium";
    font-size: toRem(18px);
    cursor: pointer;
    text-decoration: underline;
  }

  &__no-account {
    width: 100%;
    max-width: 950px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

    h1 {
      font-family: "text-regular";
      font-size: toRem(26px);
    }

    p {
      font-family: "text-medium";
      font-size: toRem(16px);
      color: #6d6d6d;

      &.is-email {
        color: var(--insights-color-16);
      }
    }

    a {
      font-family: "text-medium";
      font-size: toRem(16px);
    }

    img {
      height: 100%;
      width: auto;
      max-width: 100%;
      display: block;
      margin-left: auto;
      margin-right: 0;
    }
  }
}
</style>
